<template>
  <div id="app">
    <div class="bg-decor"></div>
    <div class="app-content">
      <tpay msg="Welcome to Your Vue.js App" />
      <portal-target name="dialog" style="position:absolute;" class="no-print" multiple />
    </div>
    <!-- -->

    <!--Портал для диалоговых окон-->

  </div>
</template>

<script>
import tpay from './components/tpay.vue'

// Костиль для оновлень сторінки
document.addEventListener("visibilitychange", () => {
  if (!document.hidden) {
    location.reload(); // Полное обновление страницы
  }
});


window.onload = () => {

  let startX;
  let startY;

  const container = document.getElementById('app');

  container.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  });

  container.addEventListener('touchmove', (e) => {
    const moveX = e.touches[0].clientX - startX;
    const moveY = e.touches[0].clientY - startY;

    if (Math.abs(moveX) > Math.abs(moveY)) {
      // Предотвратить горизонтальное смещение
      e.preventDefault();
    }
  });

  document.addEventListener('touchmove', function (event) {
    if (!event.target.closest('.app-content')) {
      event.preventDefault();
    }
  }, { passive: false });

}

export default {
  name: 'App',
  components: {
    tpay
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');

:root {
  /* Кольори для блоків */
  /* Хедер колір */
  --head: #ffffff !important;
  /* Контент колір( без чеку) */
  --content: #ffffff !important;
  /* Колір всього чеку (без буттон)  */
  /* --innerBody: red !important; */
  --innerBody: #ffffff !important;
  /* Кнопка */
  --button: #ffffff !important;
  /* Футер */
  --footer: #ffffff !important;
  /* Назва закладу */
  --text-head: #ffffff !important;
  /* Текст контенту (футер,headerText) */
  --text-content: #ffffff !important;
  /*  */
  --text-innerBody: #ffffff !important;
  /* Текст кнопки */
  --text-button: #ffffff !important;
    /* Текст футер */
  --text-footer: #ffffff !important;
  /* Відступ знизу */
  --app-bg: #ffffff !important;

}

html,
body {
  width: 100%;
  height: 100%;
  padding: 0px;
  margin: 0px;
  overflow-x: hidden;
  overflow-y: hidden;
  /* background-color: var(--innerBody); */
  background: var(--content) !important;
  /* display: flex;
  align-items: center; */

  /* -webkit-overflow-scrolling: touch;  */
}

body {
  /* width: 100vw; 
  display: flex;
  justify-content: center; 
  align-items: center;
  min-height: 100vh; 
  margin: 0;
  padding: 0;
  background: var(--app-bg) !important;
    overflow-x: hidden; */
    /* background: var(--app-bg) !important; */

}


.bg-decor {
  position: fixed;
  top: -50vh;
  left: 0;
  height: 200vh;
  background-color: var(--innerBody);
}

#app {
  width: 100%;
  height: 100%;
  
  font-family: "Helvetica Neue", Helvetica, Tahoma, sans-serif;

  /* font-family: "Manrope"; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--app-bg) !important;
  overflow-y: auto;
/* 
  max-width: 550px;
  width: 100%;
  margin: 0 auto;
  */
  
  display: flex;
  justify-content: center; 

}

.app-content {
  position: relative;
  z-index: 999;

  width: 100%;
  max-width: 550px;
  /* background-color: var(--innerBody); */
  background-color: var(--content);
  height: auto;
}
/* Swiper */

  
.swiper-pagination-bullet {
    border: 1px solid var(--button);
    background-color: transparent;
    opacity: 1;
    width: 15px;
    height: 15px;
    display: inline-block;
    /* margin: 0 4px; */
    display: flex;
    padding: 4px;
    border-radius: 50%;
  }
  
  .swiper-pagination-bullet-active {
    background-color: var(--button);
    opacity: 1;
  }
  
</style>
